/* eslint-disable */
// src/layouts/dashboard/index.js

import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { getCurrentUsername } from "utils/auth";

function getWelcomeByUsername(username) {
  const base = String(username || "").trim().toLowerCase();
  if (!base) return "Bienvenido";
  if (base.endsWith("a")) return "Bienvenida";
  return "Bienvenido";
}

function Dashboard() {
  const username = getCurrentUsername() || "usuario";
  const welcomeWord = getWelcomeByUsername(username);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        sx={{
          minHeight: "65vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10} lg={8}>
            <Box
              sx={{
                p: { xs: 4, md: 6 },
                textAlign: "center",
                borderRadius: 4,
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.9), rgba(245,247,250,0.9))",
                backdropFilter: "blur(6px)",
              }}
            >
              <MDTypography
                variant="h2"
                fontWeight="bold"
                sx={{
                  mb: 1.5,
                  letterSpacing: 0.3,
                }}
              >
                Hola, {username}
              </MDTypography>

              <MDTypography
                variant="h4"
                color="text"
                fontWeight="medium"
                sx={{ opacity: 0.95, mb: 2 }}
              >
                {welcomeWord} a Gardel Entretenimientos
              </MDTypography>

              <MDTypography variant="button" color="dark" sx={{ opacity: 0.95 }}>
                Un panel de gestión de locales, clientes, máquinas, recaudaciones.
              </MDTypography>
            </Box>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
